'use client';

import {type PropsWithChildren, useCallback} from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import {useRouter, useSearchParams} from 'next/navigation';

export const TabsRoot = Tabs.Root;

export const TabsList = Tabs.List;

export const TabsTrigger = Tabs.Trigger;

export const TabsContent = Tabs.Content;

type TabsRootProps = PropsWithChildren & {
	initialCategoryName: string;
};

export const TabsRootProductList = ({children, initialCategoryName}: TabsRootProps) => {
	const searchParams = useSearchParams();
	const router = useRouter();

	const initialCategory = searchParams.get('kategori') || initialCategoryName;

	const handleTabChange = useCallback(
		(category: string) => {
			const params = new URLSearchParams(searchParams.toString());
			params.set('kategori', category);
			router.push(`?${params.toString()}`);
		},
		[router, searchParams],
	);

	return (
		<Tabs.Root value={initialCategory} onValueChange={handleTabChange}>
			{children}
		</Tabs.Root>
	);
};
